import { defineStore } from 'pinia';
import axios from 'axios';
import { toRaw } from 'vue';

export const useGraphCompetitionAnalysisStore = defineStore('graphCompetitionAnalysis', {
	state: () => ({
		dataSet: {
			client: {
				name: '',
				data: [],
			},
			competitors: [],
		},
	}),
	getters: {
		chartSeries(state) {
			if (!state.dataSet || !state.dataSet.client || !state.dataSet.competitors) {
				return [];
			}

			const series = [
				{
					type: 'column',
					name: state.dataSet.client.name,
					data: toRaw(state.dataSet.client.data),
				},
			];

			// Add competitors dynamically
			state.dataSet.competitors.forEach(competitor => {
				series.push({
					type: 'column',
					name: competitor.name,
					data: toRaw(competitor.data),
				});
			});

			return series;
		},
	},
	actions: {
		async fetchData(selectedMarket, selectedProject, competitor_label_id = null) {
			const selected_dates = JSON.parse(localStorage.getItem('dashboardSelectedDates'));

			const response = await axios.post(
				'vuejs/competition_analysis_chart',
				{
					market_id: selectedMarket,
					project_id: selectedProject,
					date_range_start: selected_dates.from,
					date_range_end: selected_dates.to,
					competitor_label_id: competitor_label_id,
				},
				{ withCredentials: true },
			);

			this.dataSet = response.data.data;

			return response.data.data;
		},
	},
	persist: false,
});
